import { useHead, useJsonld } from '#imports'
import { useGlobalStore } from '@/stores'

export default function useSeo() {
  const globalStore = useGlobalStore()

  const title = `到府教學服務${import.meta.env.VITE_WEBSITE_TITLE}`
  const description = globalStore.seoDescriptions.inhome
  const url = `${import.meta.env.VITE_DOMAIN}/services/inhome`

  globalStore.setBreadcrumbs([
    { title: '會員服務', isActive: false, url: '/services' },
    { title: '到府教學服務', isActive: true, url: url }
  ])

  useSeoMeta({
    title: title,
    ogTitle: title,
    description: description,
    ogDescription: description
    // ogImage: faq.value.seo?.og_image?.link,
    // keywords: faq.value.seo?.meta_keywords.join(',')
  })

  useHead({
    link: [
      {
        rel: 'canonical',
        href: url
      }
    ]
  })

  useJsonld({
    '@context': 'https://schema.org',
    '@graph': [
      {
        '@type': 'BreadcrumbList',
        itemListElement: [
          {
            '@type': 'ListItem',
            position: 1,
            name: '首頁',
            item: import.meta.env.VITE_DOMAIN
          },
          {
            '@type': 'ListItem',
            position: 2,
            name: '會員服務',
            item: `${import.meta.env.VITE_DOMAIN}/services`
          },
          {
            '@type': 'ListItem',
            position: 3,
            name: '到府教學服務',
            item: url
          }
        ]
      }
    ]
  })
}
